export const fr = {
  app: {
    stepCreate: 'Créez un quiz sur mesure',
    stepShare: 'Invitez vos amis',
    stepPlay: 'Jouez',
    logoS: 'Appuyez sur le S',
  },
  footer: {
    privacy: 'Confidentialité',
    terms: 'Conditions',
    refunds: 'Remboursements',
    support: 'Assistance',
    pricing: 'Tarifs',
    x: 'X',
    instagram: 'Instagram',
  },
  billing: {
    title: 'Offres et facturation',
    subtitle: 'Rejoindre un quiz est toujours gratuit. Abonnez-vous pour créer plus de quiz.',
    planFree: 'Free',
    planBasic: 'Basic',
    planPremium: 'Premium',
    freeIncludes: '{n} quiz d’essai — pour toujours',
    quizzesPerMonth: '{n} quiz par mois',
    perMonth: '/mois',
    currentPlan: 'Votre offre actuelle',
    subscribe: 'S’abonner',
    manage: 'Gérer l’abonnement',
    remainingMonthly: 'Il vous reste {n} quiz sur {limit} ce mois-ci',
    remainingFree: 'Il vous reste {n} quiz gratuits sur {limit}',
    paymentSuccess: 'Paiement réussi ! Votre offre est active.',
    paymentActivating: 'Paiement reçu — activation de votre offre…',
    paymentCancelled: 'Paiement annulé. Aucun débit effectué.',
    signInFirst: 'Connectez-vous avec Google pour vous abonner.',
    checkoutError: 'Impossible de lancer le paiement. Veuillez réessayer.',
    backHome: 'Retour à l’accueil',
    quotaExceededTitle: 'Vous avez utilisé tous vos quiz',
    quotaExceededBody: 'Passez à une offre supérieure pour continuer à créer des quiz. Rejoindre des parties reste gratuit.',
    seePlans: 'Voir les offres',
    rematchQuotaExceeded: 'On rejoue le même quiz — la limite de l’hôte est atteinte.',
  },
  auth: {
    signInTitle: 'Connectez-vous pour créer votre quiz',
    signInHint: 'Seul l’hôte a besoin d’un compte. Vos invités rejoignent via votre lien — aucune connexion requise.',
    signInGoogle: 'Continuer avec Google',
    signInError: 'Échec de la connexion. Veuillez réessayer.',
    signedInAs: 'Connecté en tant que {email}',
    signOut: 'Se déconnecter',
    downloadIosApp: 'Télécharger l’app iOS',
    loading: 'Chargement…',
  },
  lang: {
    label: 'Langue',
    en: 'English',
    ru: 'Русский',
    es: 'Español',
    fr: 'Français',
    de: 'Deutsch',
    ja: '日本語',
    ar: 'العربية',
  },
  setup: {
    title: 'Configuration requise avant de jouer',
    step1: 'Copiez .env.local.example vers .env.local',
    step2: 'Renseignez votre URL Supabase et la clé anonyme',
    step3: 'Ajoutez votre clé API OpenAI',
    step4: 'Exécutez supabase/schema.sql dans l’éditeur SQL Supabase',
    step5: 'Redémarrez le serveur de développement',
  },
  create: {
    topic: 'Thème',
    topicPlaceholder: 'ex. dessins animés des 90, sciences, football',
    difficulty: 'Difficulté',
    difficultyEasy: 'Facile',
    difficultyMedium: 'Moyen',
    difficultyHard: 'Difficile',
    questions: 'Nombre de questions',
    modeTitle: 'Mode de jeu',
    modeRegular: 'Chaque réponse compte',
    modeRegularHint: 'Répondez tout de suite. Vous pouvez changer votre choix jusqu’à la fin du chrono, qui ne se réduit jamais — tous ceux qui répondent juste marquent. La manche se termine plus tôt seulement si tout le monde a répondu.',
    modeHardcore: 'Seule la première réponse compte',
    modeHardcoreHint: 'Seule la première bonne réponse marque. Votre réponse est verrouillée dès l’envoi — impossible de la changer, et la voix n’a qu’un essai. Les réponses sont classées par une horloge synchronisée, donc une connexion plus rapide ne compte presque pas.',
    answerTime: 'Temps pour répondre (secondes)',
    mcTitle: 'Choix multiples',
    mcHint: 'Quatre options par question — tout le monde choisit, chaque bonne réponse rapporte des points',
    cameraTitle: 'Caméras des joueurs',
    cameraHint: 'Désactivé = audio seulement (les micros fonctionnent toujours). Activé = tout le monde partage la vidéo.',
    submit: 'Créer le quiz',
    generating: 'Génération des questions',
    errorEmptyTopic: 'Veuillez saisir un thème.',
    errorGenerate: 'Échec de la génération des questions.',
    errorCreate: 'Impossible de créer la partie dans la base de données.',
    errorGeneric: 'Une erreur s’est produite.',
    createdTitle: 'Quiz créé',
    createdHint: 'Partagez ce lien avec jusqu’à 5 amis, puis entrez dans le quiz.',
    shareLink: 'Lien à partager',
    copy: 'Copier',
    copied: 'Copié',
    enterQuiz: 'Entrer dans le quiz',
    adjustShow: 'Plus',
    adjustHide: 'Masquer',
    browseOpenGames: 'Parcourir les parties ouvertes',
    browseOpenGamesHint: 'Rejoindre un quiz en attente de joueurs',
    inviteOnlyTitle: 'Lien uniquement',
    inviteOnlyHintOn: 'Seules les personnes avec votre lien peuvent rejoindre. Masqué de la liste publique.',
    inviteOnlyHintOff: 'Listé dans les parties ouvertes jusqu’au démarrage du quiz.',
  },
  rooms: {
    title: 'Parties ouvertes',
    empty: 'Aucune partie ouverte pour le moment.',
    refresh: 'Actualiser',
    join: 'Rejoindre',
    back: 'Retour',
    loading: 'Chargement…',
    error: 'Impossible de charger les parties.',
    players: '{n}/{max}',
    agoMinutes: 'il y a {n} min',
    agoHours: 'il y a {n} h',
    agoJustNow: 'À l’instant',
    modeRegular: 'Chaque bonne réponse compte',
    modeHardcore: 'Seule la première compte',
    mc: 'QCM',
    voice: 'Voix',
  },
  join: {
    title: 'Rejoindre le quiz',
    hostTitle: 'Vous êtes l’hôte',
    subtitle: 'Choisissez un nom pour que tout le monde voie votre score.',
    namePlaceholder: 'Votre nom',
    button: 'Rejoindre',
    joining: 'Connexion…',
    full: 'Cette partie est complète (jusqu’à 6 joueurs).',
    errorEmptyName: 'Veuillez saisir votre nom.',
    banned: 'Vous ne pouvez pas rejoindre à nouveau cette partie.',
  },
  lobby: {
    title: 'Salon',
    players: 'Joueurs',
    playersCount: '{n} / {max} joueurs',
    you: 'vous',
    host: 'Hôte',
    shareInvite: 'Partagez ce lien pour inviter des joueurs (jusqu’à 6 au total)',
    waitingHost: 'En attente du démarrage par l’hôte…',
    needMore: 'En attente d’au moins un autre joueur…',
    start: 'Lancer le quiz',
    removePlayer: 'Retirer',
    removeConfirm: 'Retirer {name} de cette partie ?',
    removeConfirmYes: 'Retirer',
    removeConfirmNo: 'Annuler',
    removeError: 'Impossible de retirer ce joueur.',
    listedPublicly: 'Visible dans la liste jusqu’au démarrage.',
  },
  game: {
    joining: 'Connexion à la partie',
    notFound: 'Partie introuvable',
    notFoundHint: 'Vérifiez le lien et réessayez. Si vous êtes l’hôte, créez une nouvelle partie.',
    backHome: 'Retour à l’accueil',
    removedTitle: 'Vous avez été retiré',
    removedBody: 'L’hôte vous a retiré de cette partie.',
    removedHome: 'Retour à l’accueil',
    host: 'Hôte',
    guest: 'Invité',
    live: 'En direct',
    offline: 'Hors ligne',
    waitingCamera: 'En attente de la caméra',
    cameraErrorPermission: 'Caméra/micro bloqués. Autorisez ce site, puis touchez ici.',
    cameraErrorInsecure: 'La caméra nécessite un lien sécurisé (HTTPS).',
    cameraErrorNotFound: 'Aucune caméra ou micro trouvé. Touchez pour réessayer.',
    cameraErrorBusy: 'Caméra/micro utilisés par une autre app. Touchez pour réessayer.',
    cameraErrorUnknown: 'Impossible d’accéder à la caméra/micro. Touchez pour réessayer.',
    cameraErrorTap: 'Toucher pour autoriser',
    answering: 'Réponse en cours',
    topic: 'Thème',
    question: 'Question',
    stealChance: 'Chance de voler',
    getReady: 'Préparez-vous',
    thinkHint: 'Lisez la question — la réponse se débloque pour les deux en même temps',
    answerNow: 'Répondez maintenant',
    tileAnswered: 'A répondu',
    tileThinking: 'Réfléchit…',
    youAnswering: 'Vous répondez',
    listeningAnswer: 'Écoute de la réponse',
    checkingAnswer: 'Vérification des réponses',
    speakNow: 'Parlez maintenant',
    theySpeaking: 'Ils parlent',
    secondsLeft: '{n}s restantes',
    opponentSteal: 'L’adversaire peut voler celle-ci',
    liveAnswer: 'Réponse en direct',
    correctAnswer: 'Bonne réponse',
    speakAnswerNow: 'Donnez votre réponse maintenant',
    speakHint: 'Les deux joueurs répondent à voix haute — la première bonne réponse gagne',
    yourAnswer: 'Votre réponse',
    startSpeaking: 'Commencez à donner votre réponse…',
    holdToAnswer: 'Maintenez pour répondre',
    recording: 'Enregistrement… relâchez pour envoyer',
    listening: 'Écoute…',
    holdHint: 'Maintenez le bouton et dites votre réponse',
    saidNothing: 'Pas de réponse',
    done: 'Terminé',
    doneOptional: 'Valider maintenant (facultatif)',
    autoSubmitHint: 'Votre réponse parlée est enregistrée automatiquement — inutile d’appuyer sur quoi que ce soit.',
    answerLockedIn: 'Réponse validée',
    waitingOpponent: 'En attente de l’autre joueur…',
    typeYourAnswer: 'Saisissez votre réponse ci-dessous',
    typePlaceholder: 'Ou saisissez votre réponse ici',
    waitShareLink: 'Partagez le lien avec votre adversaire pour commencer',
    waitHostStart: 'En attente du démarrage par l’hôte',
    bothIn: 'Les deux joueurs sont présents',
    questionsCount: '{n} questions',
    modeMc: 'Choix multiples',
    modeVoice: 'Donnez votre réponse',
    startQuiz: 'Lancer le quiz',
    youreIn: 'Vous êtes inscrit',
    waitHostStartOverlay: 'En attente du démarrage par l’hôte',
    waitOpponent: 'En attente de votre adversaire',
    connecting: 'Connexion à la partie',
    pointsMultiplier: '(×{n})',
  },
  buzz: {
    label: 'Buzz',
    tapFirst: 'Appuyez pour répondre en premier',
    youBuzzed: 'Vous avez buzzé, commencez à parler',
    otherAnswering: 'L’autre joueur répond',
    ariaBuzz: 'Buzz pour répondre',
    ariaDisabled: 'Buzz indisponible',
  },
  diag: {
    connected: 'Connecté',
    connecting: 'Connexion…',
    micOff: 'Aucun microphone détecté',
    micStalled: 'Aucun son reçu',
    micActive: 'Microphone actif',
    micIdle: 'Microphone coupé',
    cameraOff: 'Pas de caméra',
  },
  ptt: {
    hold: 'Maintenez pour parler',
    talking: 'En train de parler…',
    answerLive: 'Micro actif',
  },
  mc: {
    opponentSteal: 'L’adversaire peut voler celle-ci',
    answerLocked: 'Réponse validée',
    canChange: 'Vous pouvez encore changer',
    someoneAnswered: 'Quelqu’un a répondu — {n}s pour répondre !',
    you: 'Vous',
  },
  score: {
    vs: 'VS',
    streak: 'série de {n}',
    leaderboard: 'Scores',
    points: 'pts',
  },
  winner: {
    result: 'Résultat',
    winner: 'Gagnant',
    winners: 'Gagnants',
    tie: 'Égalité',
    finalScores: 'Scores finaux',
    downloadClips: 'Télécharger les extraits de réponses',
    clipLabel: 'Q{n} · réponse {role}',
    download: 'Télécharger',
    rematch: 'Revanche',
    rematchWaiting: 'En attente des autres…',
    waitRematch: 'En attente d’une revanche lancée par l’hôte',
    exit: 'Quitter',
    discuss: 'Discutez des résultats — l’appel se termine dans {n}s',
    discussHint: 'Caméra et micro coupés. Relancez pour rappeler.',
  },
} as const;
